import React from 'react';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import EventRepeatOutlined from '@mui/icons-material/EventRepeatOutlined';
import BuildOutlined from '@mui/icons-material/BuildOutlined';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { StatTile } from '../../../components/ui';

/**
 * Dashboard metrics.
 *
 * Previously each tile used a different hue for its label *and* its value, so
 * PPM was purple text and SR was indigo text for no reason a reader could infer.
 * Now every value is foreground and only the icon chip carries an accent —
 * and the one accent that means something (completion rate) is the success green.
 */
const QDFStatusCards = ({ statusCounts }) => {
  const completed = statusCounts.completedPPM + statusCounts.completedSR;
  const completionRate =
    statusCounts.total > 0 ? Math.round((completed / statusCounts.total) * 100) : 0;

  return (
    <div className="mb-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      <StatTile
        label="Total work"
        value={statusCounts.total}
        icon={AssignmentOutlined}
        accent="info"
      />
      <StatTile
        label="PPM"
        value={statusCounts.totalPPM}
        meta={`${statusCounts.activePPM} active · ${statusCounts.completedPPM} done`}
        icon={EventRepeatOutlined}
        accent="neutral"
      />
      <StatTile
        label="Service requests"
        value={statusCounts.totalSR}
        meta={`${statusCounts.activeSR} active · ${statusCounts.completedSR} done`}
        icon={BuildOutlined}
        accent="neutral"
      />
      <StatTile
        label="Completion rate"
        value={`${completionRate}%`}
        meta={`${completed} of ${statusCounts.total} completed`}
        icon={CheckCircleOutline}
        accent="success"
      />
    </div>
  );
};

export default QDFStatusCards;
